import React, { useEffect, useState } from 'react';
import MainBox from './Components/MainBox';
import AboutBox from './Components/AboutBox';
import MessageBox from './Components/MessageBox';
import SocialLinksBox from './Components/SocialLinksBox';
import ControlBar from './Components/ControlBar';
import { useNavigate, useParams } from 'react-router-dom';
import SweetAlert from 'sweetalert2'
import axios from 'axios';
import { API_URL } from '../../api';
import {useSelector} from "react-redux";
import errorIcon from "../../assets/error-icon.svg"
import { Box, Container, Grid, useTheme, alpha } from '@mui/material';

const TutorView = (props) => {
  const { tutorId } = useParams();
  const navigate = useNavigate()
  const [tutor, setTutor] = useState(null)
  const {
    _id: tutorProfileId
  } = useSelector((state) => state.profile.information);

  useEffect(() => {
    axios.get(`${API_URL}/api/teachers/${tutorId}`).then((res) => {
      if(!res.data) {
        navigate('/search')
        return showErrorMessage('Fetch tutor profile failed.')
      }
      setTutor(res.data)
    }).catch((err) => {
      console.log(err);
      navigate('/search')
      showErrorMessage(err.response?.data?.message || 'Fetch tutor profile failed.')
    })
  }, [navigate, setTutor, tutorId])

  const showErrorMessage = (message) => {
    SweetAlert.fire({
      imageUrl: errorIcon,
      imageHeight: '100px',
      title: 'Oops...',
      text: message,
      confirmButtonColor: '#712d94',
    });
  }

  const theme = useTheme()

  return (<>
    {tutor && (
      <Box sx={{ 
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        py: { xs: 2, sm: 3, md: 4 }
      }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3 } }}>
          <ControlBar tutor={tutor}/>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            {/* Left Column - Main Content */}
            <Grid item xs={12} lg={8}>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: { xs: 2, sm: 3, md: 4 }
              }}>
                <MainBox tutor={tutor} />
                <AboutBox tutor={tutor} />
              </Box>
            </Grid>
            
            {/* Right Column - Sidebar */}
            <Grid item xs={12} lg={4}>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: { xs: 2, sm: 3, md: 4 },
                position: { xs: 'relative', lg: 'sticky' },
                top: 24
              }}>
                <MessageBox tutor={tutor} />
                <SocialLinksBox tutor={tutor} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    )}
  </>
  );
};

export default TutorView;
